import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtText from "../../../components/NtText";
import NtSectionDescription from "../general/NtSectionDescription";
import NtAppDownloadButton from "../general/NtAppDownloadButton";

function NtMobileSection({}) {
  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/ff8be5d5b3ab6249a5739ba42b1b268c10d1acda.png")}
    >
      <NtSectionTitle
        style={{ marginTop: 150, fontSize: 28, fontWeight: "300" }}
      >
        FREE AND{" "}
        <NtText style={{ fontWeight: "700" }}>UNLIMITED CALLING</NtText> AND
        {"\n"} <NtText style={{ fontWeight: "700" }}>MESSAGING</NtText> WITH NT
        CONNECT
      </NtSectionTitle>

      <NtSectionDescription
        style={{
          marginTop: 8,
          textAlign: "center",
        }}
      >
        Expand your world. Catch every important moment with the people you care
        {"\n"}
        about. Home or on-the-go unlimited calling - never miss a call!
      </NtSectionDescription>

      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          marginTop: 15,
        }}
      >
        <NtAppDownloadButton
          type="android"
          containerStyle={{ marginRight: 15 }}
          onPress={() => {
            window.open(
              "https://play.google.com/store/apps/details?id=org.netTalk.smartphone"
            );
          }}
        />
        <NtAppDownloadButton
          type="apple"
          onPress={() => {
            window.open(
              "https://apps.apple.com/us/app/nt-connect-calls-messages/id397090127"
            );
          }}
        />
      </View>

      <View
        style={{
          alignItems: "center",
          justifyContent: "center",
          marginTop: 40,
        }}
      >
        <Image
          style={[
            {
              width: 400,
              height: 250,
              borderRadius: 10,
              resizeMode: "contain",
            },
          ]}
          source={require("../../../assets/images/marketing/phone-ipad.png")}
        />
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 650,
  },
});

export default NtMobileSection;
